/* tslint:disable:typedef-whitespace no-trailing-whitespace */

import {TaskUpdate, TaskUpdateType} from "@/models/task.update";

/**
 *
 * @class TaskCreateBatchComplete
 *
 * @brief sentinel progress event; batch of batches has been successfully completed.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class TaskCreateBatchComplete extends TaskUpdate {

  /** the error message */
  public message: string;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param message  the final message to show to the user
   *
   */
  constructor(id: string, message: string) {

    super(id, TaskUpdateType.Complete,100.0);

    this.message = message;
  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="model complete" class="tsp-icon" src="/assets/images/cloud-run-icon-32.png" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px); vertical-align: top; margin-top: 4px;">

    <div style="display: block;">
      <span class="tsp-label">${this.message}</span>
    </div>

  </div>

</div>`;
  }

  /** is this task complete? */
  isComplete(): boolean {

    return true;
  }

}
